import request from 'utils/request_ajax';

const sdsHost = tenant =>
  `https://service-discovery.seismic.com/api/sds/v1/tenants/${tenant}/services?useEdgeComputing=true`;

const getTenantInfo = async tenant => {
  return request.get(sdsHost(tenant), null, { cache: true });
};

const getSeismicDomain = async tenant => {
  const tenantInfo = await getTenantInfo(tenant);
  if (!tenantInfo || typeof tenantInfo !== 'object') {
    return '';
  }

  return (
    tenantInfo.tenantCustomDomain || `${tenantInfo.tenantSubdomain}.seismic.com`
  );
};

export default {
  getTenantInfo,
  getSeismicDomain,
};
